var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.readOnly)?_c('v-container',[_c('v-btn',{attrs:{"to":"/admin/saps-reports/generate","depressed":"","color":"info"}},[_vm._v("Generate Report")])],1):_vm._e(),_c('saps-report-list',{attrs:{"model-name":"report"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }